import {
  Button,
  Card,
  Collapse,
  ControlGroup,
  Elevation,
  NumericInput,
  Spinner,
  Tag,
} from "@blueprintjs/core";
import React from "react";
import { apiCallPost, niceDate } from "../fns/util";
import { inject, observer } from "mobx-react";
import cogoToast from "cogo-toast";
import _ from "lodash";
import SingleSelectWrapper from "../utils/SingleSelectWrapper";
import AsyncSelWrap from "../utils/AsyncSelWrap";
import { withRouter } from "react-router";
import { nanoid } from "nanoid";
class SxConsumption extends React.Component {
  state = {
    collapsed: true,
    /** GENERAL */
    searchingReceiving: false,
    receivingSearchResults: [],
    receivingLocationItem: null,
    searchingItems: false,
    itemSearchResults: [],
    searchItem: null,
    /** CURRENTLY CHOSEN */
    isLoadingItemInventory: false,
    currentlyChosenItemInventory: [],
    currentlyChosenItemSerialNumber: null,
    currentlyChosenItemEnteredQty: 0,
    currentlyChosenItemEnteredSubQty: 0,
    /** ITEMS */
    items: [],
    returnedItems: [],
    /** PAYMENTS */
    paymentHistory: [],
    totalPaidAmountPaise: 0,
    paidAt: null,
    enteredpaymentMode: null,
    enteredpaymentType: "",
    enteredpaymentRef: "",
    enteredpaidAmountPaise: 0,
    /** USE */
    isSurgery: false,
    isSale: false,
    relatedSxId: null,
    relatedOrderId: null,
    relatedPatientName: null,
    relatedPatientId: null,
    relatedPatientGenericID: null,
    useNotes: "",
  };
  componentDidMount() {
    if (
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.orderId
    ) {
      this.getData();
    } else {
      this.setState({ isError: true });
    }
  }

  search = async (
    string,
    searchResArray,
    isSearchingShowSpinner,
    selectedItem,
    apiUrl
  ) => {
    if (!string) {
      this.setState({
        [searchResArray]: [],
        [selectedItem]: null,
      });
      return;
    }
    try {
      this.setState({ [isSearchingShowSpinner]: true });
      let res = await apiCallPost(
        `/ims2/${this.props.authStore.prefix}/${apiUrl}/search`,
        {
          prefix: string || "",
          showWhich: "CURRENT",
        }
      );
      let results = res;

      this.setState({
        [searchResArray]: results,
        [isSearchingShowSpinner]: false,
      });
    } catch (err) {
      cogoToast.error(
        "There was an error in searching. Please check the console for more details.",
        { position: "bottom-left" }
      );
      console.log(err);
    }
  };

  confirmSale = async () => {
    let items = this.props.data.consumedItems;
    let listOfItemIDs = items.map((each) => each.itemId);
    let uniqListOfItemIDs = _.uniq(listOfItemIDs);
    let whichApi = "";
    let itemPayloadArray = [];
    for (let i = 0; i < uniqListOfItemIDs.length; i++) {
      let obj = {};
      let eligibleItems = _.filter(
        items,
        (x) => x.itemId === uniqListOfItemIDs[i]
      );
      let sample = eligibleItems[0];
      obj["location"] = this.props.data.site;
      obj["itemId"] = uniqListOfItemIDs[i];
      obj["itemEntityName"] = sample.itemEntityName;
      obj["itemSubunitName"] = sample.itemSubunitName;
      obj["itemUnitName"] = sample.itemUnitName;
      obj["itemNameSuffix"] = sample.itemNameSuffix;
      obj["itemName"] = sample.itemName;
      obj["itemTrackingType"] = sample.itemTrackingType;
      obj["itemHasExpiry"] = sample.itemHasExpiry;
      obj["recvLocation"] = this.state.recvLocation;
      obj["itemCategory"] = sample.itemCategory;

      whichApi = "actionUse";
      obj["metadata"] = {
        isSurgery: true,
        isSale: false,
        isPharmacy: false,
        isOptical: false,
        relatedSxId: this.props.data._id,
        relatedOrderId: null,
        relatedPatientName: this.props.data.patientName,
        relatedPatientId: this.props.data.patientGenericPid || null,
        relatedPatientGenericID: this.props.data.patientGenericPid,
        relatedDoctorName: this.props.data.surgeonId,
        relatedDoctorId: this.props.data.surgeonName,
        notes: "Generated from Surgery Consumption",
      };

      obj["items"] = eligibleItems.map((each) => {
        return {
          serialNumber: each.inventoryDetails.serialNumber,
          quantity: each.inventoryDetails.quantity,
          expiresOn: each.inventoryDetails.expiresOn,
          subunitOfConsumption: each.inventoryDetails.subunitOfConsumption,
        };
      });
      itemPayloadArray.push(obj);
    }
    try {
      cogoToast.loading("Creating ledger entries...");
      this.setState({ creatingLedgerEntries: true });

      await Promise.all(
        itemPayloadArray.map((y) =>
          apiCallPost(
            `/ims2/${this.props.authStore.prefix}/ledger/${whichApi}`,
            y
          )
        )
      );
      this.setState({ creatingLedgerEntries: false }, () =>
        this.props.onUpdate({ itemLedgersDone: true })
      );
      cogoToast.success("Ledger entries created.");
    } catch (err) {
      this.setState({ creatingLedgerEntries: false });
      cogoToast.error("We ran into an error creating ledger entries.");
    }
  };

  renderAddItemTopBar = () => {
    if (this.props.data.itemLedgersDone) {
      return (
        <ControlGroup>
          <Tag minimal large>
            Item Ledgers Created
          </Tag>
        </ControlGroup>
      );
    }
    return (
      <div
        style={
          this.state.isRecvLocationConfirmed
            ? {
                display: "flex",
                flexWrap: "wrap",
              }
            : {
                display: "flex",
                flexWrap: "wrap",
                "pointer-events": "none",
                opacity: 0.5,
              }
        }
      >
        <Tag minimal large icon="search">
          Search and Add Items
        </Tag>
        <AsyncSelWrap
          showSelectProp={true}
          placeholder="Items..."
          searching={this.state.searchingItems}
          items={this.state.itemSearchResults.map((each) => {
            return {
              ...each,
              item: each.entityName,
              itemName: each.entityName,
              helper: _.startCase(_.lowerCase(each.category)),
              entityTypeString: each.itemNameSuffix,
            };
          })}
          selectedItem={
            this.state.searchItem
              ? {
                  ...this.state.searchItem,
                  item: this.state.searchItem.itemNameSuffix
                    ? `${this.state.searchItem.entityName} - ${this.state.searchItem.itemNameSuffix}`
                    : this.state.searchItem.entityName,
                }
              : null
          }
          update={(item) =>
            this.search(
              item,
              "itemSearchResults",
              "searchingItems",
              "searchItem",
              "item"
            )
          }
          onChange={async (item) => {
            let id = item._id;
            let idx = _.findIndex(
              this.props.data.consumedItems,
              (x) => x._id === id
            );
            if (idx > -1) {
              cogoToast.error("You have already added this item.");
              return;
            }
            try {
              this.setState({ isLoadingItemInventory: true });
              let itemInventoryDetails = await apiCallPost(
                `/ims2/${this.props.authStore.prefix}/inventory/stock`,
                {
                  itemId: item._id,

                  location: this.state.location,
                  receivingLocationId: this.state.recvLocation._id,
                }
              );
              this.setState({
                currentlyChosenItemInventory: itemInventoryDetails,
                isLoadingItemInventory: false,
                searchItem: {
                  ...item,
                  item: `${item.entityName} - ${item.itemNameSuffix}`,
                  itemName: `${item.entityName} - ${item.itemNameSuffix}`,
                },
              });
            } catch (err) {
              this.setState({ isLoadingItemInventory: false });
              cogoToast.error(
                "We ran into an error. Please contact support if this persists"
              );
            }
          }}
        />
        {this.state.isLoadingItemInventory ? <Spinner size={20} /> : null}
        {this.renderSNChooser()}
        {this.renderCurrentInventory()}
      </div>
    );
  };
  renderSNChooser = () => {
    if (!this.state.searchItem) {
      return null;
    }
    if (
      this.state.currentlyChosenItemInventory &&
      this.state.currentlyChosenItemInventory.length
    ) {
      return (
        <ControlGroup>
          <Tag minimal large>
            Choose Serial Number
          </Tag>
          <SingleSelectWrapper
            showSelectProp={true}
            items={this.state.currentlyChosenItemInventory.map(
              (each) => each.serialNumber
            )}
            selectedItem={this.state.currentlyChosenItemSerialNumber}
            onChange={(item) => {
              this.setState({
                currentlyChosenItemSerialNumber: item,
                currentlyChosenItemEnteredQty: 0,
                currentlyChosenItemEnteredSubQty: 0,
              });
            }}
          />
        </ControlGroup>
      );
    } else {
      return (
        <Tag minimal large>
          No inventory found.
        </Tag>
      );
    }
  };
  renderCurrentInventory = () => {
    if (!this.state.currentlyChosenItemSerialNumber) {
      return null;
    }
    let item = _.find(
      this.state.currentlyChosenItemInventory,
      (x) => x.serialNumber === this.state.currentlyChosenItemSerialNumber
    );

    console.log("dsdsd", item);
    let expiryString = item.itemHasExpiry
      ? `Expires on ${niceDate(item.expiresOn)}`
      : "Does not expire";

    return (
      <ControlGroup>
        <Tag minimal large>
          {expiryString}
        </Tag>
        <Tag minimal large intent="primary">
          In Stock: {this.renderQuantityNice(item)}
        </Tag>
        {this.renderEnteredQty(item)}
      </ControlGroup>
    );
  };
  renderEnteredQty = (item) => {
    let currentQtyInteger = Math.floor(
      item.quantity / item.subunitOfConsumption
    );
    if (item.quantity < 1) {
      return (
        <Tag large minimal>
          Less than 1 quantity remaining. No action possible.
        </Tag>
      );
    }
    return (
      <ControlGroup>
        <NumericInput
          clampValueOnBlur
          min={0}
          max={currentQtyInteger}
          buttonPosition="NONE"
          style={{ width: "7em" }}
          rightElement={<Tag minimal>{item.itemUnitName}</Tag>}
          value={
            this.state.currentlyChosenItemEnteredQty / item.subunitOfConsumption
          }
          onValueChange={(num) => {
            this.setState({
              currentlyChosenItemEnteredQty: num * item.subunitOfConsumption,
            });
          }}
        />
        {item.subunitOfConsumption > 1 ? (
          <NumericInput
            clampValueOnBlur
            min={0}
            max={item.subunitOfConsumption - 1}
            buttonPosition="NONE"
            style={{ width: "7em" }}
            rightElement={<Tag minimal>{item.itemSubunitName}</Tag>}
            value={this.state.currentlyChosenItemEnteredSubQty}
            onValueChange={(num) => {
              this.setState({
                currentlyChosenItemEnteredSubQty: num,
              });
            }}
          />
        ) : null}
        {this.state.currentlyChosenItemEnteredQty +
          this.state.currentlyChosenItemEnteredSubQty >=
        1 ? (
          <Button
            icon="add"
            onClick={() => {
              // check if this itemId -- serialNumber is already added.
              let idx = _.findIndex(this.props.data.consumedItems, (x) => {
                return (
                  x.inventoryDetails.serialNumber ===
                    this.state.currentlyChosenItemSerialNumber &&
                  x.itemId === this.state.searchItem._id
                );
              });
              if (idx !== -1) {
                cogoToast.error("This item is already added to the list.");
                return;
              }
              let obj = {
                nanoid: nanoid(),
                itemId: this.state.searchItem._id,
                itemEntityName: this.state.searchItem.entityName,
                itemNameSuffix: this.state.searchItem.itemNameSuffix,
                itemName: this.state.searchItem.itemNameSuffix
                  ? `${this.state.searchItem.entityName} - ${this.state.searchItem.itemNameSuffix}`
                  : this.state.searchItem.entityName,
                itemTrackingType: this.state.searchItem.itemTrackingType,
                itemHasExpiry: this.state.searchItem.itemHasExpiry,
                itemUnitName: this.state.searchItem.itemUnitName,
                itemSubunitName: this.state.searchItem.itemSubunitName,
                itemCategory: this.state.searchItem.category,
                itemSalePrice: this.state.searchItem.itemSalePrice,
                itemSalePriceGst: this.state.searchItem.itemSalePriceGst,
                inventoryDetails: {
                  serialNumber: this.state.currentlyChosenItemSerialNumber,
                  quantity:
                    this.state.currentlyChosenItemEnteredQty +
                    this.state.currentlyChosenItemEnteredSubQty,
                  expiresOn: item.expiresOn,
                  subunitOfConsumption: item.subunitOfConsumption,
                },
              };
              this.props.onUpdate({
                changed: true,
                consumedItems: [...this.props.data.consumedItems, obj],
              });
              this.setState({
                currentlyChosenItemSerialNumber: null,
                currentlyChosenItemEnteredQty: 0,
                currentlyChosenItemEnteredSubQty: 0,
              });
            }}
          />
        ) : null}
      </ControlGroup>
    );
  };
  renderAddedItems = () => {
    if (!this.props.data.consumedItems.length) {
      return (
        <ControlGroup style={{ marginTop: "10px" }}>
          <Tag minimal large>
            No items added.
          </Tag>
        </ControlGroup>
      );
    }
    return this.props.data.consumedItems.map((each) => {
      return (
        <div style={{ marginTop: "10px", display: "flex", flexWrap: "wrap" }}>
          <Tag
            minimal
            large
            onRemove={() => {
              if (this.props.data.itemLedgersDone) {
                cogoToast.error(
                  "Cannot remove items after item ledgers are done."
                );
                return;
              }
              let list = this.props.data.consumedItems;
              let idx = _.findIndex(list, (x) => x.nanoid === each.nanoid);
              let removedItem = list[idx];
              list.splice(idx, 1);
              this.props.onUpdate({ consumedItems: list });
            }}
          >
            {each.itemName}
          </Tag>
          <Tag minimal large intent="success">
            {each.inventoryDetails.serialNumber}
          </Tag>
          {each.itemHasExpiry ? (
            <Tag minimal large intent="warning">
              Expires: {niceDate(each.inventoryDetails.expiresOn)}
            </Tag>
          ) : (
            <Tag minimal large intent="warning">
              No Expiry
            </Tag>
          )}

          {Math.floor(
            each.inventoryDetails.quantity /
              each.inventoryDetails.subunitOfConsumption
          ) ? (
            <Tag minimal large intent="warning">
              {Math.floor(
                each.inventoryDetails.quantity /
                  each.inventoryDetails.subunitOfConsumption
              )}{" "}
              {each.itemUnitName}
            </Tag>
          ) : null}

          {each.inventoryDetails.quantity %
          each.inventoryDetails.subunitOfConsumption ? (
            <ControlGroup>
              {" "}
              <Tag minimal large intent="warning">
                {each.inventoryDetails.quantity %
                  each.inventoryDetails.subunitOfConsumption}{" "}
                {each.itemSubunitName}
              </Tag>
              <Tag minimal>
                1 {each.itemUnitName} ={" "}
                {each.inventoryDetails.subunitOfConsumption}{" "}
                {each.itemSubunitName}
              </Tag>
            </ControlGroup>
          ) : null}
        </div>
      );
    });
  };
  calculateCost = (costPerUnit, gst, totalSubunits, subunitOfConsumption) => {
    let gstCost = costPerUnit + costPerUnit * (gst / 100);
    let costPerSubunit = gstCost / subunitOfConsumption;
    return costPerSubunit * totalSubunits;
  };
  renderQuantityNice = (item) => {
    let qty = item.quantitySum;
    let sub = item.subunitOfConsumption;
    let unit = item.itemUnitName;
    let subunit = item.itemSubunitName;
    let integerQty = Math.floor(qty / sub);
    let fracQty = qty % sub;
    let str = `${integerQty} ${unit}`;
    if (fracQty) {
      str = str + ` + ${fracQty} ${subunit}`;
    }
    return str;
  };
  renderItemBox = () => {
    return (
      <div>
        <ControlGroup>
          <Tag large minimal intent="primary">
            Items
          </Tag>
        </ControlGroup>
        <br />
        {this.renderAddItemTopBar()}
        {this.renderAddedItems()}
      </div>
    );
  };
  renderLocationDetails = () => {
    if (this.props.data.itemLedgersDone) {
      return null;
    }
    return (
      <ControlGroup>
        <Tag large minimal>
          Location
        </Tag>
        {this.state.recvLocationId ? (
          <ControlGroup>
            <Tag minimal large>
              {this.state.recvLocation.entityName}
            </Tag>
            {this.state.isRecvLocationConfirmed ? null : (
              <>
                {" "}
                <Button
                  icon="edit"
                  onClick={() =>
                    this.setState({
                      changed: true,
                      recvLocationId: null,
                      recvLocation: null,
                      location: null,
                      isRecvLocationConfirmed: false,
                    })
                  }
                />
                <Button
                  text="Confirm to add items"
                  onClick={() => {
                    this.setState({
                      isRecvLocationConfirmed: true,
                      changed: true,
                    });
                  }}
                />
                <Tag minimal intent="danger">
                  Can't be changed later
                </Tag>
              </>
            )}
          </ControlGroup>
        ) : (
          <AsyncSelWrap
            showSelectProp={true}
            placeholder="Receiving Locations..."
            searching={this.state.searchingReceiving}
            items={this.state.receivingSearchResults.map((each) => {
              return {
                ...each,
                item: each.entityName,
                entityTypeString: each.branchName,
                helper: each.branchStoreName,
              };
            })}
            selectedItem={
              this.state.receivingLocationItem
                ? {
                    ...this.state.receivingLocationItem,
                    item: this.state.receivingLocationItem.entityName,
                  }
                : null
            }
            update={(item) =>
              this.search(
                item,
                "receivingSearchResults",
                "searchingReceiving",
                "receivingLocationItem",
                "recvLocations"
              )
            }
            onChange={(item) => {
              this.setState({
                changed: true,
                isRecvLocationConfirmed: false,
                receivingLocationItem: item,
                recvLocation: item,
                location: item.branchName,
                recvLocationId: item._id,
              });
            }}
          />
        )}
      </ControlGroup>
    );
  };
  renderConfirmLedger = () => {
    if (this.props.data.itemLedgersDone) {
      return null;
    }
    if (!this.props.data.consumedItems.length) {
      return null;
    }
    if (!this.state.isRecvLocationConfirmed) {
      return (
        <ControlGroup>
          <Tag intent="none" large minimal>
            Consumption store location not confirmed.
          </Tag>
        </ControlGroup>
      );
    }

    return (
      <Button
        fill
        text="Confirm Consumption"
        intent="success"
        loading={this.state.creatingLedgerEntries}
        onClick={() => this.confirmSale()}
      />
    );
  };

  renderBasedOnLifecycle = () => {
    return (
      <>
        <Collapse isOpen={this.state.collapsed}>
          {" "}
          <Card elevation={Elevation.FOUR}>
            <ControlGroup style={{ marginBottom: "10px" }}>
              {" "}
              <Tag large intent="primary">
                Consumption
              </Tag>
              <Button
                icon="double-chevron-down"
                outlined
                onClick={() => this.setState({ collapsed: false })}
              />
            </ControlGroup>
          </Card>
        </Collapse>
        <Collapse isOpen={!this.state.collapsed}>
          {" "}
          <Card elevation={Elevation.FOUR} className="dark__bg">
            <ControlGroup style={{ marginBottom: "10px" }}>
              <Tag large intent="primary" fill>
                Consumption
              </Tag>{" "}
              <Button
                icon="double-chevron-down"
                outlined
                onClick={() => this.setState({ collapsed: true })}
              />
            </ControlGroup>
            <div
              style={
                this.props.canEdit
                  ? {}
                  : {
                      "pointer-events": "none",
                      opacity: 0.5,
                    }
              }
            >
              <br />
              {this.renderLocationDetails()}
              {this.renderItemBox()}
              {this.renderConfirmLedger()}
            </div>
          </Card>
        </Collapse>
      </>
    );
  };
  render() {
    return <div>{this.renderBasedOnLifecycle()}</div>;
  }
}

export default inject("authStore")(observer(withRouter(SxConsumption)));
